"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var inline_icon_1 = tslib_1.__importDefault(require("../inline-icon/inline-icon"));
var popover_1 = tslib_1.__importDefault(require("../popover/popover"));
var ArrowDownIcon_1 = tslib_1.__importDefault(require("../../../icons/compiled/components/ArrowDownIcon"));
var dropdown_scss_1 = tslib_1.__importDefault(require("./dropdown.scss"));
var key_codes_1 = tslib_1.__importDefault(require("../../constants/key-codes"));
var withStyles_1 = require("../../../common/utils/withStyles");
exports.OptionShape = prop_types_1.default.shape({
    //TODO remove;
    //@ts-ignore
    label: prop_types_1.default.string.isRequred,
    //@ts-ignore
    value: prop_types_1.default.string.isRequred,
    className: prop_types_1.default.string,
});
var Dropdown = /** @class */ (function (_super) {
    tslib_1.__extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOptionKeyDown = function (option) { return function (event) {
            if (lodash_1.includes([key_codes_1.default.SPACE, key_codes_1.default.ENTER], event.keyCode)) {
                event.preventDefault();
                _this.props.onChange(option);
                return;
            }
            var _a = event.target, previousElementSibling = _a.previousElementSibling, nextElementSibling = _a.nextElementSibling;
            if (key_codes_1.default.UP === event.keyCode) {
                event.preventDefault();
                if (previousElementSibling) {
                    previousElementSibling.focus();
                }
            }
            if (key_codes_1.default.DOWN === event.keyCode) {
                event.preventDefault();
                if (nextElementSibling) {
                    nextElementSibling.focus();
                }
            }
        }; };
        _this.setValue = function (option) { return function () {
            _this.props.onChange(option);
        }; };
        _this.saveOptionsRef = function (ref) { return (_this.optionsRef = ref); };
        _this.renderOption = function (option, key) {
            var _a;
            var _b = _this.props, optionClassName = _b.optionClassName, selectedOptionClassName = _b.selectedOptionClassName, selectedOption = _b.selectedOption;
            var isSelected = lodash_1.get(selectedOption, 'value') === option.value;
            return (react_1.default.createElement("section", { key: key, className: classnames_1.default(optionClassName, (_a = {},
                    _a[selectedOptionClassName] = isSelected,
                    _a)), role: "option", tabIndex: _this.state.isOpen ? 0 : -1, "data-selected": isSelected, "data-hook": lodash_1.isUndefined(key) ? '' : 'dropdown-option', onKeyDown: _this.handleOptionKeyDown(option), onMouseDown: _this.setValue(option) }, option.label));
        };
        _this.setIsOpen = function (isOpen) {
            _this.setState({ isOpen: isOpen }, function () {
                var _a = _this.props, selectedOption = _a.selectedOption, options = _a.options, onToggle = _a.onToggle;
                if (_this.optionsRef) {
                    var optionNode = _this.optionsRef.childNodes[lodash_1.findIndex(options, { value: selectedOption.value })];
                    if (optionNode) {
                        optionNode.focus();
                    }
                }
                onToggle(isOpen);
            });
        };
        _this.state = {
            isOpen: false,
        };
        return _this;
    }
    Dropdown.prototype.renderOptions = function () {
        return (react_1.default.createElement("div", { ref: this.saveOptionsRef }, lodash_1.map(this.props.options, this.renderOption)));
    };
    Dropdown.prototype.render = function () {
        var _a;
        var _b = this.props, selectedOption = _b.selectedOption, className = _b.className, openerClassName = _b.openerClassName, valueClassName = _b.valueClassName, arrowClassName = _b.arrowClassName, popoverClassName = _b.popoverClassName, arrowIcon = _b.arrowIcon, dataHook = _b.dataHook, ariaLabel = _b.ariaLabel, placeholder = _b.placeholder, isOpen = _b.isOpen, isRTL = _b.isRTL;
        var containerClass = classnames_1.default(dropdown_scss_1.default.container, className, (_a = {},
            _a[dropdown_scss_1.default.isOpen] = this.state.isOpen,
            _a[dropdown_scss_1.default.rtl] = isRTL,
            _a[dropdown_scss_1.default.ltr] = !isRTL,
            _a));
        var valueClass = classnames_1.default(dropdown_scss_1.default.value, valueClassName);
        var arrowClass = classnames_1.default(dropdown_scss_1.default.arrow, arrowClassName);
        return (react_1.default.createElement(popover_1.default, { ariaRole: "combobox", isOpen: isOpen, ariaLabel: ariaLabel, className: popoverClassName, openerClassName: openerClassName, focusContentOnOpen: false, dataHook: dataHook, onToggle: this.setIsOpen, content: this.renderOptions(), isRTL: isRTL },
            react_1.default.createElement("div", { className: containerClass },
                react_1.default.createElement("div", { "data-hook": "dropdown-value", className: valueClass }, selectedOption ? selectedOption.label : placeholder),
                react_1.default.createElement(inline_icon_1.default, { className: arrowClass, icon: arrowIcon }))));
    };
    Dropdown.defaultProps = {
        onChange: lodash_1.noop,
        onToggle: lodash_1.noop,
        arrowIcon: react_1.default.createElement(ArrowDownIcon_1.default, null),
        placeholder: '',
        dataHook: 'dropdown-control',
    };
    Dropdown = tslib_1.__decorate([
        withStyles_1.withStyles(dropdown_scss_1.default)
    ], Dropdown);
    return Dropdown;
}(react_1.default.Component));
exports.default = Dropdown;
//# sourceMappingURL=dropdown.js.map